module.exports = __webpack_public_path__ + "@/assets/img/007-boy-2.fcfccac7.svg";